import { useMutation, useQueryClient } from "@tanstack/react-query";
import type { IncentiveShiftOverride } from "../../models/IncentiveShiftOverride";
import { updateShiftOverride } from "../../repositories/IncentiveRepository";

export const useUpdateShiftOverrideMutation = (assetId: number) => {
	const queryClient = useQueryClient();

	return useMutation(
		(payload: IncentiveShiftOverride) => updateShiftOverride(payload, assetId),
		{
			onSuccess: async () => {
				await Promise.all([
					queryClient.invalidateQueries({ queryKey: ["incentive", assetId] }),
					queryClient.invalidateQueries({
						queryKey: ["incentive-report", assetId],
					}),
				]);
			},
		},
	);
};
